import { useState, useEffect } from "react";
import { saveUserAttendance, fetchWorkingDaysData, fetchResourceData } from "../Api/UserAttendance";
import { Container, Form, Button, Row, Col, Accordion, AccordionItem, AccordionBody, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import Select from "react-select";

const UserAttendance = () => {
  const [loading, setLoading] = useState(false);
  const [workingDaysData, setWorkingDaysData] = useState([]);
  const [resourceData, setResourceData] = useState([]);
  const [attendanceData, setAttendanceData] = useState({
    workingDaysId: "",
    resourceId: "",
    salaryDays: "",
  });
  const { user } = useAuth();
  const resourceOptions = resourceData.map((resource) => ({
  value: resource.resourceId,
  label: `${resource.resourceId} - ${resource.name}`,
}));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [workingDays, resources] = await Promise.all([
          fetchWorkingDaysData(user?.organisationId),
          fetchResourceData(user?.organisationId),
        ]);
        setWorkingDaysData(workingDays);
        setResourceData(resources);
      } catch (error) {
        toast.error("Error fetching data: " + error.message);
      }
    };
    fetchData();
  }, [user]);

  const handleChange = (e) => {
    setAttendanceData({ ...attendanceData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

  if (!attendanceData.workingDaysId) {
    toast.error("Please select Working Days.");
    return;
  }

  if (!attendanceData.resourceId) {
    toast.error("Please select Resource.");
    return;
  }

  if (
    attendanceData.salaryDays === "" ||
    attendanceData.salaryDays < 0 ||
    attendanceData.salaryDays > 31
  ) {
    toast.error("Salary Days must be between 0 and 31.");
    return;
  }
    setLoading(true);
    try {
      await saveUserAttendance(attendanceData);
      toast.success("User Attendance Saved Successfully");
      setAttendanceData({
        workingDaysId: "",
        resourceId: "",
        salaryDays: "",
      });
    } catch (error) {
        console.error("Save Attendance Error:", error);

       toast.error(
      error?.message ||
      error?.Message ||
      "Something went wrong while saving attendance."
    );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container asset-master-fields">
      <h2 className="fields-title">User Attendance Form</h2>

      <Form onSubmit={handleSubmit} className="fields-form" noValidate>
        <Accordion defaultActiveKey="0" className="asset-master-accordion">
          <AccordionItem eventKey="0">
            <AccordionBody>
              <Row className="g-3">
                {/* Working Days */}
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="workingDaysId">
                    <Form.Label>
                      Working Days ID <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Select
                      name="workingDaysId"
                      value={attendanceData.workingDaysId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Working Days ID</option>
                      {workingDaysData.map((item) => (
                        <option key={item.workingDaysId} value={item.workingDaysId}>
                          {item.workingMonth}-{item.workingYear}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Resource */}
               <Col xl={4} lg={4} md={6} sm={12}>
  <Form.Group controlId="resourceId">
    <Form.Label>
      Resource ID <span className="text-red">**</span>
    </Form.Label>

    <Select
      options={resourceOptions}
      value={
        resourceOptions.find(
          (option) =>
            option.value ===
            attendanceData.resourceId
        ) || null
      }
      onChange={(selected) =>
        setAttendanceData({
          ...attendanceData,
          resourceId: selected
            ? selected.value
            : "",
        })
      }
      placeholder="Search Resource..."
      isClearable
      isSearchable
       menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={{
    control: (base) => ({
      ...base,
      minHeight: "42px",
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),

    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  }}
    />
  </Form.Group>
</Col>

                {/* Salary Days */}
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="salaryDays">
                    <Form.Label>
                      Salary Days <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="salaryDays"
                      value={attendanceData.salaryDays}
                      onChange={handleChange}
                      min="0"
                      max="31"
                      required
                      placeholder="e.g., 22"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </AccordionBody>
          </AccordionItem>
        </Accordion>

        <div className="fields-btn-container mt-3">
          <Button
            type="submit"
            className="fields-submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Saving…
              </>
            ) : (
              "Save Attendance"
            )}
          </Button>
        </div>
      </Form>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default UserAttendance;